<script>
    import Icon from "./Icon.svelte";
    import {quadInOut} from 'svelte/easing';
    import CategoryList from "./CategoryList.svelte";
    import {clickOutside} from './clickOutSide.js';
    export let categoryData = [];

    let visible = false;

    function slideFade(node, { delay = 0, duration = 400, easing = quadInOut } = {}) {
        const style = getComputedStyle(node);
        const opacity = +style.opacity;
        const height = parseFloat(style.height);

        return {
            delay,
            duration,
            easing,
            css: t => 'overflow: hidden;' +
                `opacity: ${Math.min(t, 1) * opacity};` +
                `height: ${t * height}px;`
        };
    }

    function handleToggle(event) {
        event.preventDefault();
        visible = !visible;
    }

    function handleClickOutside() {
        visible = false
    }

</script>

<a class="category-menu-toggle"
   href="#cater"
   on:click={handleToggle}
   use:clickOutside
   on:click_outside={handleClickOutside}>
    <Icon></Icon>
    Nasze kategorie
</a>

{#if visible}
    <div class="category-container" transition:slideFade="{{duration: 350, easing: quadInOut}}">
        <CategoryList {categoryData}></CategoryList>
    </div>
{:else}
    <div class="category-container collapsed">
        <CategoryList {categoryData}></CategoryList>
    </div>
{/if}

<style>
    .category-container {
        position: absolute;
        /*z-index: -1;*/
    }

    .category-container.collapsed {
        display: none;
    }

    @media (min-width: 768px) and (max-width: 991px) {
        a.category-menu-toggle {
            min-width: 250px;
        }
    }

    a.category-menu-toggle {
        float: left;
        display: inline-block;
        color: #fff!important;
        background: #0a95da;
        padding: 15px 20px;
        font-size: 17px;
        font-weight: 700;
        box-sizing: border-box;
        text-align: left;
    }
</style>
